import { toolBase } from "../toolBase";

export class EmbedTool extends toolBase {
    getToolTipName() {
        return "Встраиваемый контент";
    }

    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.1191 7.32539C5.31443 7.13051 5.6307 7.1307 5.8258 7.3258L6.17431 7.67431C6.36937 7.86937 6.3696 8.18555 6.17483 8.3809L2.6368 11.9294C2.59789 11.9684 2.59789 12.0316 2.6368 12.0706L6.17483 15.6191C6.3696 15.8145 6.36937 16.1306 6.17431 16.3257L5.8258 16.6742C5.6307 16.8693 5.31443 16.8695 5.1191 16.6746L1.14317 12.7079C0.751551 12.3172 0.751551 11.6828 1.14317 11.2921L5.1191 7.32539ZM18.1742 7.3258C18.3693 7.1307 18.6856 7.13051 18.8809 7.32539L23.2116 11.646C23.4074 11.8414 23.4074 12.1586 23.2116 12.354L18.8809 16.6746C18.6856 16.8695 18.3693 16.8693 18.1742 16.6742L17.8257 16.3257C17.6306 16.1306 17.6304 15.8145 17.8252 15.6191L21.3632 12.0706C21.4021 12.0316 21.4021 11.9684 21.3632 11.9294L17.8252 8.3809C17.6304 8.18555 17.6306 7.86937 17.8257 7.67431L18.1742 7.3258ZM8.90856 21C8.56728 21 8.32629 20.6657 8.43422 20.3419L14.0553 3.47864C14.1506 3.1928 14.4181 3 14.7194 3H15.0914C15.4327 3 15.6737 3.33435 15.5658 3.65811L9.9447 20.5214C9.84942 20.8072 9.58193 21 9.28063 21H8.90856Z" fill="#2C2D32"/>
            </svg>
        `;
    }

    name = "embedTool";
}
